<template>
  <q-banner rounded class="text-white bg-red-4">
    <template v-slot:avatar>
      <q-icon name="warning" size="md" color="white" />
    </template>
    {{ label }}
  </q-banner>
</template>

<script>
export default {
  props: {
    label: String,
  },
};
</script>
